<div class="row new-layer-area">
  <div class="col-md-3 text-center">
    <div class="new-layer">
      <button class="btn btn-primary btn-block" (click)="createLayer()" [disabled]="!isAllowedCreateLayerWithoutAudio() || storyboard.read_only"><i class="fa fa-plus"></i> Add New Layer</button>
    </div>
  </div>
  <div class="col-md-6 control-bar">
    <div class="control-tool" *ngIf="timelineService.playerControl">
      <span class="backward"><i class="fa fa-fast-backward" (click)="timelineService.playerControl.seekToBeginning()"></i></span>
      <span class="play" *ngIf="timelineService.playerControl.playing()" (click)="pause()">
        <img src="/assets/images/icons/pause_icon.png" height="52" width="52"/>
      </span>
      <span class="play" *ngIf="timelineService.playerControl.paused()" (click)="play()">
        <img src="/assets/images/play_btn.png" height="52" width="52"/>
      </span>
      <span class="forward"><i class="fa fa-fast-forward" (click)="timelineService.playerControl.seekToEnd()"></i></span>
    </div>
  </div>
  <div class="col-md-3 control-bar d-flex align-items-center justify-content-end">
    <button class="btn undo-btn" *ngIf="historyLength > 1" (click)="undo()">
      <i class="fa fa-undo"></i> 
      Undo
    </button>
    <div class="zoom-tool" (mousewheel)="mosueWheelZoom($event)">
      <span (click)="zoomOut()" class="zoom-out" [ngClass]="{'disabled' : isZoomOutDisabled()}"><i class="fa fa-minus"></i></span>
      <span (click)="resetZoom()" class="zoom">{{ getZoom() }}%</span>
      <span (click)="zoomIn()" class="zoom-in" [ngClass]="{'disabled' : isZoomInDisabled()}"><i class="fa fa-plus"></i></span>
    </div>
    <div class="mute-tool" *ngIf="timelineService.playerControl" (click)="timelineService.playerControl.toggleMute()">
      <i class="fa" [ngClass]="{'fa-volume-off' : timelineService.playerControl.isMuted(), 'fa-volume-up': !timelineService.playerControl.isMuted()}"></i>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/control-bar/control-bar.component.html